var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85272 24H50.145C50.145 24 52.395 24 52.395 26.25V51C52.395 51 52.395 53.25 50.145 53.25H6.85272C6.85272 53.25 4.60272 53.25 4.60272 51V26.25C4.60272 26.25 4.60272 24 6.85272 24Z",
    stroke: "#1AC760",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2277 19.4798L10.8622 15.7471C10.9118 15.4557 11.0183 15.1769 11.1756 14.9268C11.333 14.6766 11.5381 14.4598 11.7792 14.2889C12.0203 14.118 12.2927 13.9962 12.5809 13.9306C12.8691 13.865 13.1674 13.8569 13.4587 13.9066L43.674 19.0501",
    stroke: "#1AC760",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.683 8.99925L18.0892 5.217C18.2971 4.65804 18.7184 4.20447 19.2606 3.95597C19.8027 3.70748 20.4213 3.68438 20.9805 3.89175L43.3297 12.201",
    stroke: "#1AC760",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2296 29.6243L33.8554 35.25L28.2296 40.8757L22.6039 35.25L28.2296 29.6243Z",
    stroke: "#1AC760",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8527 46.5H41.7277",
    stroke: "#1AC760",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4a78f79d8bdd7b18c1df8b5107736534.svg";
export { ForwardRef as ReactComponent };